/**
 * descargar.ts — entregarle un archivo a quien lo pidió.
 *
 * Ocho líneas que estaban copiadas en dos pantallas, y con la de cierre iban a
 * ser tres. No es una regla de negocio, y por eso el motivo de juntarlas no es
 * el de siempre: es que **la que se olvida es la última**.
 *
 * ▶ `revokeObjectURL` NO ES LIMPIEZA OPCIONAL.
 *
 * Sin él, el blob se queda en memoria hasta que se cierre la pestaña. Un
 * contador que exporta los cuatro estados de doce meses hace cuarenta y ocho
 * descargas en una sesión, y son archivos de verdad. La copia que no lo llame
 * no se ve rota: simplemente ocupa.
 */

/** Le entrega el `blob` al navegador con ese nombre. No decide el nombre: lo trae la API. */
export function descargarArchivo(nombre: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  a.click();
  URL.revokeObjectURL(url);
}
